import { useCallback, useContext } from 'react';

import { TokenScheme, customCardTypesConfig } from '../constants';
import {
  TokenSchemeType,
  TokenexInitConfigType,
  TokenexConfigType,
  TokenexCssType,
} from '../@types';
import { TokenexContext } from '../contexts';

const generateStyles = (styles: TokenexCssType) => ({
  ...styles,
  cvv: {
    ...styles,
  },
});

export const getTokenexConfigPCI = (
  config: TokenexInitConfigType,
  styles: TokenexCssType,
): TokenexConfigType => ({
  ...config,
  enablePrettyFormat: true,
  // enableValidateOnBlur: true,
  returnKhash: false,
  placeholder: '0000 0000 0000 0000',
  debug: false,
  pci: true,
  cvv: false,
  maskInput: 'false',
  useExtendedBIN: 'true',
  inputType: 'text',
  inputMaxLength: 19,
  styles: generateStyles(styles),
  customDataTypes: customCardTypesConfig,
});

export const getTokenexConfigCVV = (
  config: TokenexInitConfigType,
  styles: TokenexCssType,
): TokenexConfigType => ({
  ...config,
  enablePrettyFormat: true,
  // enableValidateOnBlur: true,
  debug: false,
  pci: false,
  customRegEx: '^\\d{3,4}$',
  maskInput: 'false',
  inputType: 'text',
  inputMaxLength: 4,
  styles: generateStyles(styles),
  allowUnknownCardTypes: true,
});

export const useTokenexContext = (scheme: TokenSchemeType) => {
  const ctx = useContext(TokenexContext);

  const getTokenexConfig = useCallback(
    (styles: TokenexCssType) => {
      if (scheme === TokenScheme.Card && ctx)
        return getTokenexConfigPCI(ctx.tokenexConfig.card, styles);
      if (scheme === TokenScheme.CVV && ctx && ctx.tokenexConfig.cvv)
        // eslint-disable-next-line nonblock-statement-body-position
        return getTokenexConfigCVV(ctx.tokenexConfig.cvv, styles);

      return null;
    },
    [scheme, ctx],
  );

  return {
    getTokenexConfig,
  };
};
